import { Link } from 'react-router-dom';
import { PHONE_TEL, PHONE_DISPLAY } from '../../../lib/businessInfo';

interface ReadyToShopCtaProps {
  cityName: string;
}

export default function ReadyToShopCta({ cityName }: ReadyToShopCtaProps) {
  return (
    <section className="py-16 bg-gradient-to-br from-[#1A2332] via-[#2C3E55] to-[#1A2332] text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
            <i className="ri-shopping-cart-line text-[#E8B84B]"></i>
            <span className="text-sm font-medium">Ready to Find Your Perfect Car?</span>
          </div>

          <h2 className="font-oswald text-3xl md:text-4xl font-bold mb-4">
            Start Your Journey Today
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            Browse our inventory, explore financing options, or get in touch with our team. 
            We're here to help {cityName} residents find the perfect vehicle.
          </p>

          <div className="grid md:grid-cols-3 gap-4 mb-10">
            <Link
              to="/inventory"
              className="group bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/20 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-[#E8B84B] rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-car-line text-2xl text-[#1A2332]"></i>
              </div>
              <h3 className="font-oswald text-xl font-bold mb-2">Browse Inventory</h3>
              <p className="text-sm text-white/80 mb-3">
                View our hand-selected vehicles
              </p>
              <div className="flex items-center justify-center gap-2 text-[#E8B84B] font-semibold">
                <span>Shop Now</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>

            <Link
              to="/financing"
              className="group bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/20 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-[#E8B84B] rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-bank-card-line text-2xl text-[#1A2332]"></i>
              </div>
              <h3 className="font-oswald text-xl font-bold mb-2">Get Financing</h3>
              <p className="text-sm text-white/80 mb-3">
                Flexible options for all credit types
              </p>
              <div className="flex items-center justify-center gap-2 text-[#E8B84B] font-semibold">
                <span>Learn More</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>

            <Link
              to="/contact"
              className="group bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/20 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-[#E8B84B] rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-customer-service-2-line text-2xl text-[#1A2332]"></i>
              </div>
              <h3 className="font-oswald text-xl font-bold mb-2">Contact Us</h3>
              <p className="text-sm text-white/80 mb-3">
                Speak with our friendly team
              </p>
              <div className="flex items-center justify-center gap-2 text-[#E8B84B] font-semibold">
                <span>Get in Touch</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          </div>

          <div className="flex flex-wrap justify-center gap-4">
            <a
              href={PHONE_TEL}
              className="inline-flex items-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              Call: {PHONE_DISPLAY}
            </a>
            <Link
              to="/inventory"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line text-xl"></i>
              Search Inventory
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export { ReadyToShopCta };